import { Modal, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CalendarSubscribeOptions } from 'src/Components/Shared/CalendarSubscribeOptions';

import styles from './CalendarSyncModal.module.scss';
import { Props } from './CalendarSyncModal.types';

const CalendarSyncModal = ({ open, onClose, icalUrl }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={open}
      onClose={onClose}
      title={
        <div className={styles.title}>
          {t('calendarSync.title', 'Synchroniser avec un calendrier')}
        </div>
      }
      withCloseButton={true}
    >
      <div className={styles.container}>
        <Text size="sm" c="dimmed" className={styles.description}>
          {t(
            'calendarSync.description',
            'Abonnez-vous à ce calendrier pour voir les événements dans votre application de calendrier préférée. Les événements seront mis à jour automatiquement.'
          )}
        </Text>

        <CalendarSubscribeOptions icalUrl={icalUrl} layout="modal" context="app" />
      </div>
    </Modal>
  );
};

export default CalendarSyncModal;
